import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import tastePanelDetailDataAccess, {
  TastePanelDetail,
} from "src/dataAccess/tastePanel/tastePanelDetail.DataAccess";

export const loadingTastePanelDetail = createAction<boolean>(
  "[TastePanelDetail] Loading detail"
);

export const AddTastePanelDetail = createAction<any>("Add TastePanelDetail Success");

export const removeUnsavedTastePanelDetail = createAction<number>("[TastePanelDetail] Remove Unsaved Detail");

export const updateTastePanelDetailValue = createAction<TastePanelDetail[]>(
  "[TastePanelDetail] Update TastePanelDetail Value"
);

export const getTastePanelDetailListAsync = createAsyncThunk<
  TastePanelDetail[],
  number | string
>("[TastePanelDetail] Get by TastePanelId", async (tastePanelId, thunkAPI) => {
  thunkAPI.dispatch(loadingTastePanelDetail(true));
  const res = await tastePanelDetailDataAccess.getByTastePanelId(tastePanelId);
  const result = res.data ?? [];
  thunkAPI.dispatch(loadingTastePanelDetail(false));
  return result;
});

export const deleteTastePanelDetailAsync = createAsyncThunk<
  { success: boolean; message: string; id: string },
  string
>("[TastePanelDetail] Delete TastePanelDetail", async (id, thunkAPI) => {
  const res = await tastePanelDetailDataAccess.deleteTastePanelDetail(id);
  return { ...res, id };
});

export const saveTastePanelDetailsAsync = createAsyncThunk<
  TastePanelDetail[],
  TastePanelDetail[]
>(
  "[TastePanelDetail] Save All TastePanelDetails",
  async (details, thunkAPI) => {
    thunkAPI.dispatch(loadingTastePanelDetail(true));
    const res = await tastePanelDetailDataAccess.saveTastePanelDetails(details);
    thunkAPI.dispatch(loadingTastePanelDetail(false));
    return res.data;
  }
);

